import { CONSTANTS_GENERATION__slider_step } from '@shared/constants/CONSTANTS_GENERATION__slider_step';
import { CONSTANTS_GENERATION__value_range as CONSTANTS } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { MAP__fields_by_role } from '@shared/types/types';
import { ENUM__ip_adapter_method } from '../../../_enums/ENUM__ip_adapter_method';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { DECORATOR__ui_without_component } from '../../_base/_decorators/DECORATOR__ui_without_component';
import { ENUM__field_graph_interaction } from '../../_base/_enums/ENUM__field_graph_interaction';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base_visible_connectable } from '../../_base/FIELD__base_connectable';
import { DECORATOR__class_serialization_tested } from '../../_primitives/_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../../_primitives/_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_is_input } from '../../_primitives/_base/DECORATOR__field_is_input';
import { DECORATOR__field_not_linked } from '../../_primitives/_base/DECORATOR__field_not_linked';
import { FIELD__list_image_asset } from '../../_primitives/list/FIELD__list_image_asset';
import { FIELD_PRIMITIVE__float } from '../../_primitives/number/FIELD_PRIMITIVE__float';
import { FIELD_PRIMITIVE__string_enum } from '../../_primitives/string/FIELD_PRIMITIVE__string_enum';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../../_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { ENUM__image_asset_category } from '../../ENUM__image_asset_category';
import { ENUM__image_transform, ENUM_UTILS__image_transform } from '../../image/_enums/ENUM__image_transform';
import { FIELD__image_asset } from '../../image/FIELD__image_asset';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD__ml_asset_ip_adapter extends FIELD__base_visible_connectable {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_ML_ASSET_IP_ADAPTER;

  /*
   *
   */
  static sort_by_hash(a: FIELD__ml_asset_ip_adapter, b: FIELD__ml_asset_ip_adapter) {
    let hash_a = a.model__ip_adapter.get_value();
    let hash_b = b.model__ip_adapter.get_value();

    return hash_a.localeCompare(hash_b);
  }

  /*
   * FIELDS
   */
  @FIELD_PRIMITIVE__string_hash_ml_asset.init_field_with_type(ENUM__ml_asset_type.IP_ADAPTER)
  model__ip_adapter!: FIELD_PRIMITIVE__string_hash_ml_asset;

  @FIELD_PRIMITIVE__string_hash_ml_asset.init_field_with_type(ENUM__ml_asset_type.IMAGE_ENCODER)
  model__image_encoder!: FIELD_PRIMITIVE__string_hash_ml_asset;

  @FIELD__list_image_asset.init_as_field({
    category: ENUM__image_asset_category.IMAGE,
    item_options: MAP__serializable.from_object({
      preprocessing_transform__current: ENUM__image_transform.FILL,
      preprocessing_transform__allowed: ENUM_UTILS__image_transform.get_all_except_none(),
    }),
    item_meta: MAP__serializable.from_object({
      graph__interaction: ENUM__field_graph_interaction.HIDDEN,
      ui__has_component: false,
    }),
  })
  images!: FIELD__list_image_asset;

  //todo:use field_role: '🔳 IPA Mask'
  @FIELD__image_asset.init_as_field_transform_stretch({ category: ENUM__image_asset_category.MASK }, {})
  mask!: FIELD__image_asset;

  // todo: use list depends on steps
  @FIELD_PRIMITIVE__float.init_as_input({
    value: 1.0,
    value_range: CONSTANTS.WEIGHT_RANGE,
    values_allowed: CONSTANTS.WEIGHT_ALLOWED,
    //
    slider_step: CONSTANTS_GENERATION__slider_step.WEIGHT_DEFAULT,
    slider_step_values: CONSTANTS_GENERATION__slider_step.WEIGHT_VALUES,
  })
  weight!: FIELD_PRIMITIVE__float;

  @FIELD_PRIMITIVE__string_enum.register_input__enum(ENUM__ip_adapter_method.FULL, ENUM__ip_adapter_method)
  method!: FIELD_PRIMITIVE__string_enum;

  @FIELD_PRIMITIVE__float.init_as_field({
    value: 0.0,
    value_range: CONSTANTS.ZERO_TO_ONE,
    values_allowed: CONSTANTS.ZERO_TO_ONE,

    //
    slider_step: CONSTANTS_GENERATION__slider_step.WEIGHT_DEFAULT,
    slider_step_values: CONSTANTS_GENERATION__slider_step.WEIGHT_VALUES,
  })
  step_percent_begin!: FIELD_PRIMITIVE__float;

  @FIELD_PRIMITIVE__float.init_as_field({
    value: 1.0,
    value_range: CONSTANTS.ZERO_TO_ONE,
    values_allowed: CONSTANTS.ZERO_TO_ONE,
    //
    slider_step: CONSTANTS_GENERATION__slider_step.WEIGHT_DEFAULT,
    slider_step_values: CONSTANTS_GENERATION__slider_step.WEIGHT_VALUES,
  })
  step_percent_end!: FIELD_PRIMITIVE__float;

  /*
   * METHODS
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.ML_ASSET__IP_ADAPTER;
  }

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    return this.meta.field_hash__value_full;
  }

  @DECORATOR__field_not_linked()
  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    if (this.images.items.is_empty()) return false;
    if (this.weight.get_value() == 0) return false;
    if (this.step_percent_begin.get_value() == this.step_percent_end.get_value()) return false;

    return super.has_effect_on_generation_runtime(graph);
  }

  prepare_for_usage_in(graph: DTO_GRAPH__instance) {
    super.prepare_for_usage_in(graph);

    /*
     * STEP PERCENT
     */

    this.step_percent_begin.sync_with_field_max(this.step_percent_end);
  }

  /*
   * HASH
   */

  @DECORATOR__ui_without_component
  post_init(): void {
    super.post_init();
  }

  update_fields_aliases(fields_map: MAP__fields_by_role) {
    super.update_fields_aliases(fields_map);

    this.try_set_field_role(fields_map, this.weight, `💪 ${this.meta.field_role} Weight`);
    this.try_set_field_role(fields_map, this.method, `🎨 ${this.meta.field_role} Method`);
    this.try_set_field_role(fields_map, this.images, `🖼️ ${this.meta.field_role} Images`);

    this.try_set_field_role(fields_map, this.step_percent_begin, `🏁 ${this.meta.field_role} Begin at %`);
    this.try_set_field_role(fields_map, this.step_percent_end, `🏁 ${this.meta.field_role} End at %`);

    this.try_set_field_role(fields_map, this.model__ip_adapter, `📦 ${this.meta.field_role} Model`);
    this.try_set_field_role(fields_map, this.model__image_encoder, `📦 ${this.meta.field_role} Image Encoder`);

    for (let [index, field] of this.images.items.entries()) {
      this.try_set_field_role(fields_map, field, `🖼️ ${this.meta.field_role}. Image ${index}`);
    }
  }

  @DECORATOR__field_is_input()
  @DECORATOR__field_not_linked()
  store__serialization_keys_list_white_for_hash(): string[] {
    let out: (keyof this)[] = ['model__ip_adapter', 'model__image_encoder', 'images', 'mask', 'weight', 'method', 'step_percent_begin', 'step_percent_end'];
    return out as string[];
  }
}
